module.exports = __webpack_public_path__ + "static/media/12@720w.6a5af728.jpg";